// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8346":"css/admin-app.6813","8502":"css/app.6813"}[chunkId] + ".css";
};